module.exports = __webpack_public_path__ + "static/assets/2bc3d5a33fea3306a3222986c32fbeec.png";